import React from 'react';
import { useAppState } from '../hooks/useAppState';
import CelebrationEffect from '../components/CelebrationEffect';
import QRCodeImage from '../components/QRCodeImage';
import { getConfig } from '../services/configManager';
import { formatDate } from '../utils/validation';
import CouponCard from '../components/CouponCard';
import CalculatorCard from '../components/CalculatorCard';

const MemberThankYouPage: React.FC = () => {
  const { state, resetState } = useAppState();
  const { currentTicket, orderResponse } = state;

  const handleBackToHome = () => {
    resetState();
  };


  return (
    <div className="flex-1 flex items-center justify-center p-5">
      <div className="container-card w-full max-w-sm">
        <h1 className="text-title font-extrabold text-black text-center mb-8">
          Thank You!
        </h1>

        <div className="text-center text-black text-md mb-8">
          <div>
            <p className="mb-4">
              Welcome to Park & Go! Your account has been created successfully.
            </p>
          </div>
        </div>


        
        {/* Ticket Summary */}
        {currentTicket && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-black text-lg mb-3 text-center">Ticket Summary</h2>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Ticket:</span>
                <span className="text-black font-medium">{currentTicket.ticketNumber || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Parking Lot:</span>
                <span className="text-black font-medium">{currentTicket.spot?.name || currentTicket.spot?.code || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Car Plate:</span>
                <span className="text-black font-medium">{currentTicket.vehicleNumber || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Entry:</span>
                <span className="text-black font-medium">{formatDate(currentTicket.entryDate)}</span>
              </div>
            </div>
          </div>
        )}
        
        {/* Order Information */}
        {orderResponse && (
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-black text-lg mb-3 text-center">Order Information</h2>
            <div className="space-y-3">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Customer:</span>
                <span className="text-black font-medium">
                  {orderResponse.order.contact.firstName} {orderResponse.order.contact.lastName}
                </span>
              </div>
              {orderResponse.order.contact.email && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Email:</span>
                <span className="text-black font-medium">
                  {orderResponse.order.contact.email}
                </span>
              </div>
              )}
              
                             {/* QR Code */}
               {(orderResponse.order.options?.showQR !== false) && (
               <div className="flex flex-col items-center space-y-2">
                 <hr className="w-full border-t border-gray-200 my-1" />
                 <h3 className="font-semibold text-black text-lg text-center">Your Credential</h3>
                 <p className="text-gray-700 text-sm text-center">
                   This QR code is your credential. Scan it at the entry or exit terminal to get in or out.
                 </p>
                 <QRCodeImage
                   qrCodeUrl={getConfig().API.QR_CODE_URL.replace('{order-id}', orderResponse.order.id)}
                   alt="Order QR Code"
                   className="w-48 h-48 border border-gray-300 rounded"
                   maxRetries={5}
                   retryDelay={3000}
                 />
                 <p className="text-gray-500 text-xs text-center">
                   Present at the terminal scanner when needed.
                 </p>
               </div>
               )}
            </div>
          </div>
        )}

        <div className="text-center text-black text-md mb-8">
          <div>           
            <p className="mb-4">
              You can now enjoy our member benefits including:
            </p>
            <ul className="text-left space-y-2 mb-4">
              <li>• Faster exits with automatic payment</li>
              <li>• Email receipts for all transactions</li>
              <li>• Easy access to your parking history</li>
              <li>• Member-only discounts and offers</li>
            </ul>
            <p>
              Your account is ready for use!
            </p>
          </div>
        </div>

        <CouponCard />
        <CalculatorCard />
        
        <div className="flex flex-col gap-4">
          <button
            onClick={() => {
              window.location.href = getConfig().API.LOGIN_URL;
            }}
            className="btn-primary w-full"
          >
            To my account
          </button>
          
          {/* <button
            onClick={handleBackToHome}
            className="btn-primary w-full"
          >
            Back to Home
          </button> */}
        </div>
      </div>
      
      {/* Celebration Effect */}
      <CelebrationEffect duration={5000} starCount={20} />
    </div>
  );
};

export default MemberThankYouPage; 